import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { AlertService } from '../../../../core/services/alert.service';
import { SchedulerListService } from '../../../../common/scheduler/components/list/list.service';
import { SchedulerListDragDropService } from '../../../../common/scheduler/services/list-drag-drop.service';
import { SchedulerListComponent } from '../../../../common/scheduler/components/list/list.component';
import { SchedulerItemOnListDirective } from '../../../../common/scheduler/directives/template.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';

import { PackingBoxSalesOrderRankListService } from './list.service';
import { ApiRouteTransactionDto } from '../../../../api/elite/dto/purchase-order.dto';
import { SchedulerDragDropApiAbstract } from '../../../../common/scheduler/api/drag-drop';
import { PackingBoxSalesOrderRankDragDropApiService } from './drag-drop-api.service';
import { MatIconModule } from '@angular/material/icon';
import { CacheTableService } from '../../../../common/packing-box/services/cache-table.service';

export type PackingBoxSalesOrderRankType = {
  data: DataInfo;
  response: DataResponse;
};

type DataInfo = {
  rowId: string;
  disableRankSales?: boolean;
};
type DataResponse = {
  transactions: ApiRouteTransactionDto['insert']['body'][];
  list: { id: number; rank: string }[];
  netsuiteSaleordersId: number[];
};
@Component({
  selector: 'app-po-so-rank',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    SchedulerListComponent,
    SchedulerItemOnListDirective,
    MatButtonModule,
    MatListModule,
    MatIconModule,
  ],
  templateUrl: './so-rank.component.html',
  styleUrls: ['./so-rank.component.sass'],
  providers: [
    {
      provide: SchedulerListService,
      useClass: PackingBoxSalesOrderRankListService,
    },
    SchedulerListDragDropService,
    {
      provide: SchedulerDragDropApiAbstract,
      useClass: PackingBoxSalesOrderRankDragDropApiService,
    },
  ],
})
export class PackingBoxSalesOrderRankComponent implements OnInit {
  private readonly data: DataInfo = inject(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef);
  private readonly listService = inject(
    SchedulerListService
  ) as PackingBoxSalesOrderRankListService;
  private readonly alertService = inject(AlertService);
  private readonly cacheTableService = inject(CacheTableService);

  allAreNewItems = false;
  disableRankSales = this.data.disableRankSales ?? false;

  ngOnInit(): void {
    const dataSalesOrder = this.cacheTableService.getSaleOrderCalculated(
      this.data.rowId
    );
    this.listService.list = dataSalesOrder;
    this.allAreNewItems = dataSalesOrder.every((item) => item.isInserted);
    this.listService.keepStatic = this.disableRankSales;
  }

  onClose(): void {
    const wo = this.cacheTableService.getWorkoreder(this.data.rowId);

    if (!wo) {
      this.alertService.error('Error interrno');
      return;
    }
    const assembly = wo.assemblyItem;
    const toInsert = this.listService.salesOrderToInsert(assembly);
    const toModify = this.listService.salesOrdersToModify();
    const fullList = this.cacheTableService.getSaledOrderFromNestsuite(
      this.data.rowId
    );
    const ids = fullList
      .map((data) => data.saleOrderId)
      .filter((id) => id != null);
    if (toInsert.length === 0 && toModify.length === 0) {
      this.alertService.error('no hay cambios que gaurdar');
      return;
    }
    this.dialogRef.close({
      transactions: toInsert,
      list: toModify,
      netsuiteSaleordersId: ids,
    });
  }
}
